import React, { FunctionComponent } from 'react';
import RealtimePageComponent from '@/components/pageComponents/RealtimePageComponent';
import ImageHeaderLayout from '@/pages/layouts/ImageHeaderLayout';
import StaticPageHeader from '@/components/layout/headers/StaticPageHeader';
import { getStaticPage, StaticPageStructure } from '@/pageGeneration/services/prismicApi/staticPagesApi';
import PageSeo from '@/components/seo/PageSeo';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import { getUserTestimonials, IUserTestimonialSection } from '@/pageGeneration/services/prismicApi/userTestimonials';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';

interface IProps {
  pageStructure: StaticPageStructure;
  userTestimonialSection: IUserTestimonialSection;
}

const PAGE_ID = 'realtime';

const Realtime: FunctionComponent<IProps> = ({ pageStructure, userTestimonialSection }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.STATIC, name: 'Real-time' });
  return (
    <UnprotectedPage>
      <ImageHeaderLayout
        imageUrl={pageStructure.heroImage.url}
        headerContent={<StaticPageHeader title={pageStructure.title} subtitle={pageStructure.subtitle} />}
      >
        <PageSeo title={pageStructure.title} />
        <RealtimePageComponent
          contentTop={pageStructure.contentTop}
          contentMiddle={pageStructure.contentMiddle}
          userTestimonialSection={userTestimonialSection}
        />
      </ImageHeaderLayout>
    </UnprotectedPage>
  );
};

export async function getStaticProps() {
  try {
    const pageStructureData = await getStaticPage(PAGE_ID);
    const userTestimonialData = await getUserTestimonials();

    return packageStaticProps({
      pageStructure: pageStructureData,
      userTestimonialSection: userTestimonialData,
    });
  } catch (e) {
    return {
      notFound: true,
    };
  }
}

export default Realtime;
